
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Pourquoi le référencement Google est essentiel pour votre site",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Comprendre l'importance du référencement Google pour accroître la visibilité de votre site, attirer plus de visiteurs et développer votre activité en ligne.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Référencement Google : pourquoi est-ce important ?",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Cet article vous explique pourquoi votre référencement dans Google est capital et comment améliorer le vôtre.",
        },
      ],
    };
  },
};
